import {AfterViewInit, Component, Input, OnInit, ViewChild,} from '@angular/core';
import {FormControl} from '@angular/forms';
// import { Common } from "../../../../../../domain/categorie/common";
// import { hasrequiredField } from "../../../../../../utils/Hasrequired";
// import { AppTranslateService } from "../../../../../services/translate/app-translate.service";
// import { CommonSelectService } from "../../../../../services/Common/common-select.service";
// import { ToastService } from "../../../../../toast/toast.service";
// import { isSomeInputsChanged } from "../../../../../../utils/ng-changes";
import {MatSelectFilterComponent} from 'mat-select-filter';
import {MatSelect} from '@angular/material/select';
import {Common} from 'src/app/domain/categorie/common';
import {hasrequiredField} from 'src/app/utils/Hasrequired';
import {CommonSelectService} from 'src/app/modules/services/Common/common-select.service';
import {AppTranslateService} from 'src/app/modules/services/translate/app-translate.service';
import {ToastService} from 'src/app/modules/toast/toast.service';
import {Router} from '@angular/router';

@Component({
    selector: 'app-combo-commande',
    templateUrl: './combo-commande.component.html',
    styleUrls: ['./combo-commande.component.css']
})
export class ComboCommandeComponent implements OnInit, AfterViewInit {

    @Input() control: FormControl;
    @Input() controlFils: FormControl;
    @Input() label = 'test';
    @Input() labelFils = 'Classification détaillée';
    @Input() code = 'EP01';
    codefils = '';
    @Input() withfiltre = false;
    disabled = true;
    list: Common[] = [];
    listsearch: Common[] = [];
    listFils: Common[] = [];
    listsearchFils: Common[] = [];
    isLoading = false;
    isLoadingFils = false;
    required = hasrequiredField;
    requiredFils = hasrequiredField;
    @ViewChild('MatSelect') select: MatSelect;
    @ViewChild('MatSelect') selectFils: MatSelect;

    @Input() muliple = false;
    @ViewChild(MatSelectFilterComponent) filter: MatSelectFilterComponent;
    @ViewChild(MatSelectFilterComponent) filterFils: MatSelectFilterComponent;
    classification: string;

    constructor(
        private commonSelectService: CommonSelectService,
        private appTranslateService: AppTranslateService,
        private router: Router,
        private toastService: ToastService
    ) {
    }

    get isReady() {
        return Array.isArray(this.list);
    }

    get isReadyFils() {
        return Array.isArray(this.listFils);
    }

    ngOnInit(): void {
        this.disabled = true;


        this.fetchlist();
        this.fetchlistFils();
    }

    change(e) {
        this.filter?.searchForm.reset();
        this.disabled = true;
        if (this.control.value == 2391) {
            this.disabled = false;
            this.codefils = 'EP41';
        }

        if (this.control.value == 2392) {
            this.disabled = false;
            this.codefils = 'EP43';
        }
        if (this.control.value == 2393) {
            this.disabled = false;
            this.codefils = 'EP45';
        }
        if (this.control.value == 2394) {
            this.disabled = false;
            this.codefils = 'EP47';
        }

        this.fetchlistFils();
    }

    changeFils(e) {
        this.filterFils?.searchForm.reset();


    }

    getlang() {
        return this.appTranslateService.getDefaultLang();
    }

    clear($event: MouseEvent) {
        $event.stopPropagation();
        this.control.setValue(undefined);

        this.disabled = true;


    }

    clearFils($event: MouseEvent) {
        $event.stopPropagation();
        this.controlFils.setValue(undefined);
        //  this.disabled=true

    }

    ngAfterViewInit(): void {
        this.fetchlist();
        this.fetchlistFils();
    }

    getDisabledValue() {

        if (this.codefils == '') {
            return true;
        }//your condition, in this case textarea will be disbaled.
        else {
            return false;
        }
    }

    private fetchlist() {
        this.isLoading = true;
        if (this.router.url.includes('fournisseur')) {
            this.commonSelectService.getlistFournisseur(this.code).subscribe({
                next: (cat) => {
                    this.list = cat.payload;
                    this.listsearch = cat.payload;

                    this.listsearch?.map(
                        (item) => (item.motcle = item.cdNmAr + '' + item.cdNmFr)
                    );


                },
                error: (e) => {
                    this.toastService.error();

                    this.isLoading = false;
                },
                complete: () => {
                    this.isLoading = false;
                },
            });

        }else {
            this.commonSelectService.getlist(this.code).subscribe({
                next: (cat) => {
                    this.list = cat.payload;
                    this.listsearch = cat.payload;

                    this.listsearch?.map(
                        (item) => (item.motcle = item.cdNmAr + '' + item.cdNmFr)
                    );


                },
                error: (e) => {
                    this.toastService.error();

                    this.isLoading = false;
                },
                complete: () => {
                    this.isLoading = false;
                },
            });

        }

    }

    private fetchlistFils() {
        this.isLoadingFils = true;
        if (this.codefils != '') {
            if (this.router.url.includes('fournisseur')) {
                this.commonSelectService.getlistFournisseur(this.code).subscribe({
                    next: (cat) => {
                        this.list = cat.payload;
                        this.listsearch = cat.payload;

                        this.listsearch?.map(
                            (item) => (item.motcle = item.cdNmAr + '' + item.cdNmFr)
                        );


                    },
                    error: (e) => {
                        this.toastService.error();

                        this.isLoading = false;
                    },
                    complete: () => {
                        this.isLoading = false;
                    },
                });

            }else {
                this.commonSelectService.getlist(this.codefils).subscribe({
                    next: (cat) => {
                        this.listFils = cat.payload;
                        this.listsearchFils = cat.payload;

                        this.listsearchFils?.map(
                            (item) => (item.motcle = item.cdNmAr + '' + item.cdNmFr)
                        );


                    },
                    error: (e) => {
                        this.toastService.error();

                        this.isLoadingFils = false;
                    },
                    complete: () => {
                        this.isLoadingFils = false;
                    },
                });

            }
        }
    }
}
